<template>
  <div v-if="client">
    <div>
      <div class="columns">
        <div class="column is-narrow">
          <app-logo></app-logo>
        </div>
        <div class="column">
          <div class="card">
            <header class="header-card">
              <p>
                {{ $t('editionClient.generalTitle.generalInformations')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-3">
                  <b-field :label="$t('editionClient.informations.code')">
                    <b-input v-model="client.code" disabled></b-input>
                  </b-field>
                </div>
                <div class="column is-3">
                  <input-tier-nom-commercial
                      :label="$t('editionClient.informations.tradeName')"
                      v-model="client.nomCommercial"
                      :tierId="client.id"
                      :query="clientQuery"
                      path="c.bodac.clients/contacts-client">
                  </input-tier-nom-commercial>
                </div>
                <div class="column is-3">
                  <b-field :label="$t('editionClient.informations.legalName')">
                    <b-input v-model="client.nomJuridique"></b-input>
                  </b-field>
                </div>
                <div class="column is-3">
                  <b-field :label="$t('editionClient.informations.typologie')">
                    <b-select v-model="client.typologie" expanded
                              @input="removeTiersParentAndDataGroupeEnseigne">
                      <option v-for="typologie in listeTypologie"
                              :value="typologie.code"
                              :key="typologie.code">
                        {{ $t(typologie.libelle) }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column is-3">
                    <b-field :label="$t('editionClient.divers.tiersMarque')"
                              :class="isMarqueObligatoire ? 'obligatoire' : ''">
                            <query-marque-tag-input
                                v-model="client.tiersMarques"
                                field="marque"
                                :parametreKey="parametreMarque">
                             </query-marque-tag-input>
                     </b-field>
                </div>
                <div class="column is-3">
                  <b-field :label="$t('editionClient.informations.applicationTva')">
                    <b-select v-model="client.applicationTva" expanded>
                      <option
                        v-for="item in constantes.LISTE_APPLICATION_TVA"
                        :value="item.code"
                        :key="item.code">
                        {{ $t(item.libelle) }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column is-6">
                  <b-field :label="$t('editionClient.informations.tags')">
                    <query-tags-tag-input
                      :tooltipLabel="$t('editionClient.informations.tagInfo')"
                      position="is-top"
                      v-model="client.tags"
                      field="tag"
                      :moduleTag="constantes.CLIENT">
                    </query-tags-tag-input>
                  </b-field>
                </div>
                <div class="column is-narrow">
                  <b-field class="has-text-default bfieldWhitoutLabel">
                    <b-checkbox v-model="client.factureParMail">
                      {{ $t('editionClient.informations.factureParMail')}}
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column is-narrow">
                  <b-field class="has-text-default bfieldWhitoutLabel">
                    <b-checkbox v-model="client.prospect">
                      {{ $t('editionClient.informations.prospect')}}
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column is-narrow">
                  <b-field class="has-text-default bfieldWhitoutLabel">
                    <b-checkbox v-model="client.domTom">
                      {{ $t('editionClient.informations.domTom')}}
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column is-narrow" v-if="moduleStockTiersActive">
                  <b-field class="has-text-default bfieldWhitoutLabel">
                    <b-checkbox v-model="client.lieuStockage">
                      {{ $t('editionClient.informations.lieuStockage')}}
                    </b-checkbox>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgb-20px"
           v-if="client.typologie === pointVente || client.typologie === enseigne">
        <header class="header-card" >
          <p>
            {{ $t('editionClient.generalTitle.organisation')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns">
            <div class="column is-narrow mgt-5px has-text-default has-text-weight-bold">
              {{ client.typologie === enseigne
              ? $t('editionClient.informations.organisation.selectGroupe')
              : $t('editionClient.informations.organisation.selectEnseigne')
              }}
            </div>
            <div class="column is-6">
              <b-autocomplete
                v-model="tiersParent"
                :data="dataEnseigneOrGroupe"
                field="nomCommercial"
                @select="option => client.tiersParentId = option ? option.id : null"
                @typing="getEnseigneOrGroupe"
                :loading="isFetchingEnseigneOrGroupe" >
                <template slot="empty">
                  <div v-if="!isFetchingEnseigneOrGroupe">
                    {{$t('editionClient.informations.organisation.noResult')}}
                  </div>
                  <div v-else>{{$t('editionClient.informations.organisation.search')}}</div>
                </template>
              </b-autocomplete>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <header class="header-card" >
          <p>
            {{ $t('editionClient.generalTitle.address')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns">
            <div class="column is-6">
              <b-field :label="$t('editionClient.informations.postalAddress')">
                <app-adresse
                  :displayGMap="true"
                  :adresse="client.adressePostale"
                  adresseName='adressePostale'
                  :tableName="TIERS"/>
              </b-field>
            </div>
            <div class="column is-6">
            <span>
            <b-checkbox v-model="client.adresseFacturationDifferente"
                        @input="selectionAdresseFacturationclient()">
              {{ $t('editionClient.informations.addressBillingDifferent')}}
            </b-checkbox>
            <app-adresse :adresse="client.adresseFacturation"
                         adresseName='adresseFacturation' class="mgt-5px"
                         :tableName="TIERS"
                         v-if="client.adresseFacturationDifferente"/>
            </span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <br/>
    <div class="columns">
      <div class="column is-6">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('editionClient.generalTitle.contactInformations')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.phone')">
                  <b-input v-model="client.telephone"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.cellPhone')">
                  <b-input v-model="client.portable"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <app-input-email :label="$t('editionClient.informations.email')"
                                 v-model="client.email"/>
              </div>
              <div class="column is-6">
                <app-input-url  :label="$t('editionClient.informations.webSite')"
                                v-model="client.siteWeb"/>
              </div>
              <div class="column is-6 is-invisible" >
                <b-field label="Invisible">
                  <b-input ></b-input>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('editionClient.generalTitle.administrativeInformations')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.siret')">
                  <b-input v-model="client.siret"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.ape')">
                  <b-input v-model="client.ape"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.intracommunityTva')">
                  <b-input v-model="client.tvaIntracommunautaire"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <parametre-autocomplete
                  :label="$t('editionClient.informations.activity')"
                  v-model="client.secteurActiviteId"
                  :target="constantes.PARAMETRES_KEYS.secteurActivite"
                  expanded
                />
              </div>
              <div class="column is-6">
                <parametre-autocomplete
                  :label="$t('editionClient.informations.profil')"
                  v-model="client.profilTiersId"
                  :target="constantes.PARAMETRES_KEYS.profilTiers"
                  expanded
                />
              </div>
              <div class="column is-6">
                <user-selector
                  v-model="client.commercialId"
                  :label="$t('editionClient.informations.trade')"
                  :critere="(u) => [constantes.COMMERCIAL, constantes.DIRECTEUR_COMMERCIAL]
                    .includes(u.profil)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionClient.generalTitle.contacts')}}
        </p>
      </header>
      <div class="card-content">
        <app-contacts
          :contacts="client.contacts"
          :client="client"/>
      </div>
    </div>
    <br>

    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('editionClient.generalTitle.bankDetails')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.rib.bank')">
                  <b-input v-model="client.rib.banque"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.rib.holder')">
                  <b-input v-model="client.rib.titulaire"></b-input>
                </b-field>
              </div>
              <div class="column is-9">
                <input-iban :label="$t('editionClient.informations.rib.iban')"
                            v-model="client.rib.iban"/>
              </div>
              <div class="column is-3">
                <b-field :label="$t('editionClient.informations.rib.bic')">
                  <b-input v-model="client.rib.bic"></b-input>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('editionClient.generalTitle.regulationsInformations')}}
            </p>
          </header>
          <div class="card-content">
            <app-informations-reglements :client="client"/>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="card height-100">
          <header class="header-card">
            <p>
              {{ $t('editionClient.generalTitle.accountingInformations')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.accountingAccount')">
                  <b-input v-model="client.compteComptable"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.typeMandatSepa')">
                  <b-input :value="libelleTypeMandat" :disabled="true"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.referenceUniqueMandat')">
                  <b-input v-model="client.referenceUniqueMandat"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="$t('editionClient.informations.dateSignatureMandatSepa')">
                  <b-datepicker show-week-number
                                nearby-selectable-month-days
                                v-model="client.dateSignatureMandatSepa"
                                icon="calendar-today"
                                :editable="true">
                  </b-datepicker>
                </b-field>
              </div>
              <div class="column is-6" v-if="moduleFactorActive">
                <tiers-autocomplete
                  v-model="client.factor"
                  :societeActiveId="societeActiveId"
                  :type="constantes.TIERS_TYPE_FOURNISSEUR"
                  :sousTypes="[constantes.TIERS_SOUS_TYPE_FACTOR]"
                  :label="$t('editionClient.informations.factor')"
                  @input="changeFactor"
                  openOnFocus>
                <template slot-scope="{ option }">
                  <p>
                    <span v-if="option.code">{{ option.code }} </span>
                    <span>{{ option.nomCommercial }}</span>
                  </p>
                  <p class="is-size-8 is-italic">
                    <span v-if="option.compteComptable">{{ option.compteComptable }} </span>
                    <span>{{ option.adressePostaleLibelle }}</span>
                  </p>
                </template>
                </tiers-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <honoraire :tiers="client" :isEdit="true"></honoraire>
      </div>
      <div class="column is-6" v-if="societeActive.roles.length > 1">
        <role-vendeur :tiers="client"></role-vendeur>
      </div>
      <div class="column" :class="societeActive.roles.length === 1 ? 'is-12' : 'is-6'">
        <info-commande :tiers="client"></info-commande>
      </div>
    </div>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionClient.generalTitle.comments')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-4">
            <b-field :label="$t('editionClient.informations.commentsOrderForm')">
                <textarea class="textarea"
                          rows="6"
                          v-model="client.commentairesBonDeCommandes"></textarea>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('editionClient.informations.commentsBilling')">
                <textarea class="textarea"
                          rows="6"
                          v-model="client.commentairesFacturation"></textarea>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('editionClient.informations.commentsIntern')">
                <textarea class="textarea"
                          rows="6"
                          v-model="client.commentairesInternes"></textarea>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('editionClient.informations.instructionsDemat')">
                <textarea class="textarea"
                          rows="6"
                          v-model="client.instructionDematerialisation"></textarea>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px">
      <div class="column is-6">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('editionClient.generalTitle.divers')}}
            </p>
          </header>
          <div class="card-content">
            <app-info-divers :client="client"></app-info-divers>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <info-periode-budgetaire :client="client"></info-periode-budgetaire>
      </div>
      <div class="column is-12" v-if="portailClientBaseUrl">
        <div class="card height-100">
          <header class="header-card">
            <p>
              {{ $t('editionClient.generalTitle.portail')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-4">
                <qd-switch v-model="client.portail">
                  <span class="has-text-default">
                    {{ $t(client.portail ? 'editionClient.portail.activePortail'
                    : 'editionClient.portail.desactivePortail') }}
                  </span>
                </qd-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes :checkPermissions="true"/>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import genererGuid from '@/services/general/genererGuid';
import Adresse from '@/components/general/adresse';
import InputEmail from '@/components/general/inputEmail';
import InputIban from '@/components/general/inputIban';
import InputUrl from '@/components/general/inputUrl';
import { getAll } from '@/api/tiers/index';
import adresseGenerer from '@/services/general/genererAdresse';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import PiecesJointes from '@/components/general/piecesJointes';
import Logo from '@/components/general/Logo';
import messageErreur from '@/services/general/messageErreur';
import * as clientConf from '@/configuration/tiers/tiersConf';
import appInfoDivers from '@/components/clients/clients/editionClient/infoDivers';
import roleVendeur from '@/components/clients/clients/editionClient/roleVendeur';
import infoCommande from '@/components/commun/tiers/editionTiers/infoCommande';
import honoraire from '@/components/clients/clients/honoraire/honoraire';
import infoPeriodeBudgetaire from '@/components/clients/clients/editionClient/infoPeriodeBudgetaire';
import InputTierNomCommercial from '@/components/general/input/tierNomCommercialInput/tierNomCommercialInput';
import { TIERS } from '@/configuration/ville/villeConf';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import userSelector from '@/components/commun/user/userSelector';
import queryMarqueTagInput from '@/components/general/tagInput/queryMarqueTagInput';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import tiersAutocomplete from '@/components/general/autocomplete/tiersAutocomplete';
import { CLIENT } from '@/configuration/parametrage/tagConf';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';
import InformationsReglements from './informationsReglements';
import Contacts from './contacts';

const Parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'edition-client',
  props: ['client', 'error'],
  components: {
    appAdresse: Adresse,
    appContacts: Contacts,
    appPiecesJointes: PiecesJointes,
    appLogo: Logo,
    appInformationsReglements: InformationsReglements,
    appInputEmail: InputEmail,
    appInputUrl: InputUrl,
    appInfoDivers,
    roleVendeur,
    infoCommande,
    honoraire,
    infoPeriodeBudgetaire,
    InputIban,
    InputTierNomCommercial,
    userSelector,
    queryMarqueTagInput,
    tiersAutocomplete,
    queryTagsTagInput,
    ParametreAutocomplete,
  },
  data() {
    return {
      TIERS: TIERS,
      contact: {},
      types: ['Logo', 'Iban', 'Mandat', 'Divers'],
      message: '',
      name: '',
      image: null,
      tiersParent: '',
      keepFirst: false,
      openOnFocus: false,
      dataEnseigneOrGroupe: [],
      isFetchingEnseigneOrGroupe: false,
      listeTypologie: clientConf.LISTE_TYPOLOGIE,
      pointVente: clientConf.TYPOLOGIE_POINT_DE_VENTE,
      enseigne: clientConf.TYPOLOGIE_ENSEIGNE,
      groupe: clientConf.TYPOLOGIE_GROUPE,
      constantes: {
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
        LISTE_APPLICATION_TVA: clientConf.LISTE_APPLICATION_TVA,
        TIERS_TYPE_FOURNISSEUR: clientConf.TIERS_TYPE_FOURNISSEUR,
        TIERS_SOUS_TYPE_FACTOR: clientConf.TIERS_SOUS_TYPE_FACTOR,
        CLIENT,
        PARAMETRES_KEYS,
      },
      parametreMarque: PARAMETRES_KEYS.marque,
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne(
        [typesParametres.PARAMETRES_INTERNE_KEYS.portailClientBaseUrl.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.moduleFactor.key,
          PARAMETRES_INTERNE_KEYS.marqueObligatoirePointDeVenteSpe.key],
      );
      if (this.client.tiersParent) this.tiersParent = this.client.tiersParent.nomCommercial;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    isMarqueObligatoireSpeActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.marqueObligatoirePointDeVenteSpe.key);
    },
    isMarqueObligatoire() {
      return this.isMarqueObligatoireSpeActive
      && (this.client.typologie === this.pointVente || this.client.typologie === this.enseigne);
    },
    portailClientBaseUrl() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.portailClientBaseUrl.key,
      );
    },
    moduleStockTiersActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
      );
    },
    moduleFactorActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleFactor.key);
    },
    clientQuery() {
      return {
        nomCommercial: this.client.nomCommercial,
        societeId: this.societeActiveId,
        type: clientConf.TIERS_TYPE_CLIENT,
        sousType: [clientConf.TIERS_SOUS_TYPE_AUCUN],
      };
    },
    libelleTypeMandat() {
      return this.$t(
        clientConf.LISTE_TYPE_MANDAT.find(t => t.code === this.client.typeMandatSepa)?.libelle,
      );
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    changeFactor(option) {
      this.client.factorId = option?.id ?? null;
    },
    removeTiersParentAndDataGroupeEnseigne() {
      this.tiersParent = null;
      this.client.tiersParentId = null;
      this.dataEnseigneOrGroupe = [];
    },
    getEnseigneOrGroupe: debounce(function ClientData() {
      this.dataEnseigneOrGroupe = [];
      this.client.tiersParentId = null;
      if (!this.tiersParent) return;
      this.isFetchingEnseigneOrGroupe = true;
      const query = {
        query: {
          nomCommercialCompteComptable: this.tiersParent,
          societeId: this.societeActiveId,
          typologie: [this.client.typologie === this.pointVente ? this.enseigne : this.groupe],
          type: clientConf.TIERS_TYPE_CLIENT,
          sousType: [clientConf.TIERS_SOUS_TYPE_AUCUN],
        },
      };
      getAll(query).then((response) => {
        response.data.result.items.forEach((client) => {
          if (client.id !== this.client.id) this.dataEnseigneOrGroupe.push(client);
        });
        this.isFetchingEnseigneOrGroupe = false;
      }).catch(() => {
        this.isFetchingEnseigneOrGroupe = false;
      });
    }, 500),
    uploadFile() {
      const fichierCourant = this.image[0];
      const pieceJointe = {
        id: genererGuid(),
        isLogo: true,
        type: 'Logo',
        description: '',
        nom: fichierCourant.name,
        file: { ...fichierCourant },
      };
      const file = this.client.piecesJointes.find((el) => { return el.isLogo; });
      if (file) {
        this.client.piecesJointes.splice(this.client.piecesJointes.indexOf(file), 1, pieceJointe);
      } else {
        this.client.piecesJointes.push(pieceJointe);
      }
    },
    selectionAdresseFacturationclient() {
      if (!this.client.adresseFacturationDifferente) {
        this.client.adresseFacturation = adresseGenerer();
      }
    },
  },
};
</script>

<style lang="scss">
</style>
